export default "__VITE_ASSET__BqYsj29r__"